import { Create, SimpleForm, NumberInput, SelectInput, TextInput, useGetList } from 'react-admin';
import { useLocation } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';

const parseOptions = (options) => {
  if (!options) return [];
  if (Array.isArray(options)) return options.map(o => ({ id: String(o).trim(), name: String(o).trim() }));
  if (typeof options === 'string') return options.split(',').map(o => ({ id: o.trim(), name: o.trim() })).filter(o => o.id);
  return [];
};

const DynamicFields = ({ productId }) => {
  const { data: attributes = [], isLoading } = useGetList('attributes', {
    filter: { product_id: productId },
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'id', order: 'ASC' },
  });

  if (isLoading) return <CircularProgress size={20} />;
  if (!attributes.length) return (
    <Typography variant="body2" color="text.secondary">
      אין תכונות מוגדרות למוצר זה. הוסף תכונות קודם בעמוד עריכת המוצר.
    </Typography>
  );

  return (
    <>
      {attributes.map(attr => {
        const choices = parseOptions(attr.options);
        return choices.length > 0 ? (
          <SelectInput
            key={attr.id}
            source={`attr_${attr.key}`}
            label={attr.label || attr.key}
            choices={choices}
            fullWidth
          />
        ) : (
          <TextInput
            key={attr.id}
            source={`attr_${attr.key}`}
            label={attr.label || attr.key}
            fullWidth
          />
        );
      })}
    </>
  );
};

const VariantCreate = () => {
  const location = useLocation();
  const productId = location.state?.record?.product_id;

  const transform = (data) => {
    const attributes = {};
    const clean = { product_id: productId };
    for (const [key, value] of Object.entries(data)) {
      if (key.startsWith('attr_')) {
        attributes[key.slice(5)] = value;
      } else if (key !== 'product_id') {
        clean[key] = value;
      }
    }
    return { ...clean, attributes };
  };

  return (
    <Create transform={transform} title="וריאנט חדש">
      <SimpleForm defaultValues={{ product_id: productId }}>
        <TextInput source="name" label="שם המוצר (למשל: תפילין גסות אשכנזי גודל 7)" fullWidth />

        <Box sx={{ width: '100%', mb: 2 }}>
          <Typography variant="subtitle2" color="text.secondary" mb={1}>
            תכונות המוצר
          </Typography>
          <DynamicFields productId={productId} />
        </Box>

        <Box className="crm-form-grid" sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 2, width: '100%' }}>
          <NumberInput source="price_ils" label="מחיר ₪" min={0} fullWidth />
          <NumberInput source="price_usd" label="מחיר $"  min={0} fullWidth />
          <NumberInput source="quantity"  label="כמות במלאי" min={0} fullWidth />
        </Box>
      </SimpleForm>
    </Create>
  );
};

export default VariantCreate;
